module.exports = __webpack_public_path__ + "img/tp3.686ee750.jpg";